import type { ExpressParams } from '@rover/react-lib/types';

const getUrlParameter = (name: string, expressParams: ExpressParams | null | undefined) => {
  const match = new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(window.location.search);
  return decodeURIComponent(((match && match[1]) || '').replace(/\+/g, '%20')) || null;
};

export default getUrlParameter;



// WEBPACK FOOTER //
// ../utilities/getUrlParameter.client.ts